import _slicedToArray from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _createForOfIteratorHelper from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.reduce.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "login-container"
};
var _hoisted_2 = {
  class: "login-title"
};
var _hoisted_3 = {
  style: {
    "width": "30%",
    "float": "right",
    "text-align": "right",
    "height": "38px"
  }
};
var _hoisted_4 = ["src"];
import { getCaptcha } from '@/api/system/auth';
import Particle from './Particle.vue';
import defaultSetting from '@/settings.js';
import useStore from '@/store';
import { onMounted, reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup: function setup(__props) {
    var validateUsername = function validateUsername(rule, value, callback) {
      if (value == null || value === '') {
        callback(new Error('请输入用户名'));
      } else if (value.length < 4) {
        callback(new Error('用户名长度不能小于4个字符'));
      } else if (value.length > 20) {
        callback(new Error('用户名长度不能大于20个字符'));
      } else {
        callback();
      }
    };
    var validatePassword = function validatePassword(rule, value, callback) {
      if (value == null || value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 6) {
        callback(new Error('密码长度不能小于6个字符'));
      } else if (value.length > 20) {
        callback(new Error('密码长度不能大于20个字符'));
      } else {
        callback();
      }
    };
    var validateCaptcha = function validateCaptcha(rule, value, callback) {
      if (value == null || value === '') {
        callback(new Error('请输入验证码'));
      } else if (value.length !== 4) {
        callback(new Error('验证码长度为4个字符'));
      } else {
        callback();
      }
    };
    var title = ref(defaultSetting.title);
    var loginForm = reactive({
      username: '',
      password: '',
      captchaCode: '',
      captchaId: ''
    });
    var loginRules = {
      username: [{
        required: true,
        trigger: 'blur',
        validator: validateUsername
      }],
      password: [{
        required: true,
        trigger: 'blur',
        validator: validatePassword
      }],
      captchaCode: [{
        required: true,
        trigger: 'blur',
        validator: validateCaptcha
      }]
    };
    var router = useRouter();
    var loginFormRef = ref();
    var usernameRef = ref();
    var passwordRef = ref();
    var route = useRoute();
    var capsTooltip = ref(false);
    var loading = ref(false);
    var redirect = ref();
    var captchaImage = ref('');
    var otherQuery = ref();
    var store = useStore();
    watch(route, function () {
      var query = route.query;
      if (query) {
        redirect.value = query.redirect;
        otherQuery.value = queryStringToObj(redirect.value);
      }
    }, {
      immediate: true
    });
    refreshCaptcha();
    onMounted(function () {
      if (loginForm.username === '') {
        var _usernameRef$value;
        (_usernameRef$value = usernameRef.value) === null || _usernameRef$value === void 0 || _usernameRef$value.focus();
      } else if (loginForm.password === '') {
        var _passwordRef$value;
        (_passwordRef$value = passwordRef.value) === null || _passwordRef$value === void 0 || _passwordRef$value.focus();
      }
    });
    function checkCapslock(e) {
      var key = e.key;
      capsTooltip.value = !!key && key.length === 1 && key >= 'A' && key <= 'Z';
    }
    function refreshCaptcha() {
      getCaptcha().then(function (res) {
        captchaImage.value = res.data.image;
        loginForm.captchaId = res.data.id;
      });
    }
    function handleLogin() {
      var _loginFormRef$value;
      (_loginFormRef$value = loginFormRef.value) === null || _loginFormRef$value === void 0 || _loginFormRef$value.validate(function (valid) {
        if (valid) {
          loading.value = true;
          store.user.login(loginForm).then(function () {
            router.push({
              path: redirect.value || '/',
              query: otherQuery.value
            });
            loading.value = false;
          }).catch(function () {
            refreshCaptcha();
            loading.value = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
    function queryStringToObj(queryString) {
      var urlObj = new URL('https://example.com' + queryString);
      var params = new URLSearchParams(urlObj.search);
      var obj = {};
      var _iterator = _createForOfIteratorHelper(params.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            key = _step$value[0],
            value = _step$value[1];
          obj[key] = value;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return obj;
    }
    function getOtherQuery(query) {
      return Object.keys(query).reduce(function (acc, cur) {
        if (cur !== 'redirect') {
          acc[cur] = query[cur];
        }
        return acc;
      }, {});
    }
    return function (_ctx, _cache) {
      var _component_IEpUser = _resolveComponent("IEpUser");
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_IEpKey = _resolveComponent("IEpKey");
      var _component_el_tooltip = _resolveComponent("el-tooltip");
      var _component_IEpLock = _resolveComponent("IEpLock");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Particle), _createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, _toDisplayString(title.value), 1)]), _cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "login-left-box"
      }, null, -1)), _createVNode(_component_el_form, {
        ref_key: "loginFormRef",
        ref: loginFormRef,
        model: loginForm,
        rules: loginRules,
        class: "login-form",
        autocomplete: "on",
        "label-position": "left"
      }, {
        default: _withCtx(function () {
          return [_cache[5] || (_cache[5] = _createElementVNode("div", {
            class: "title-container"
          }, [_createElementVNode("h1", {
            class: "title"
          }, "欢迎登录")], -1)), _createVNode(_component_el_form_item, {
            prop: "username"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                ref_key: "usernameRef",
                ref: usernameRef,
                modelValue: loginForm.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return loginForm.username = $event;
                }),
                placeholder: "用户名",
                name: "username",
                type: "text",
                tabindex: "1",
                maxlength: 20,
                autocomplete: "on"
              }, {
                prefix: _withCtx(function () {
                  return [_createVNode(_component_IEpUser)];
                }),
                _: 1
              }, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_tooltip, {
            visible: capsTooltip.value,
            content: "大写已开启",
            placement: "right",
            manual: ""
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_form_item, {
                prop: "password"
              }, {
                default: _withCtx(function () {
                  return [_createVNode(_component_el_input, {
                    ref_key: "passwordRef",
                    ref: passwordRef,
                    modelValue: loginForm.password,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return loginForm.password = $event;
                    }),
                    type: "password",
                    "show-password": "",
                    "auto-complete": "on",
                    placeholder: "密码",
                    tabindex: "2",
                    maxlength: 20,
                    onKeypress: checkCapslock,
                    onBlur: _cache[2] || (_cache[2] = function ($event) {
                      return capsTooltip.value = false;
                    }),
                    onKeyup: _withKeys(handleLogin, ["enter"])
                  }, {
                    prefix: _withCtx(function () {
                      return [_createVNode(_component_IEpKey)];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["visible"]), _createVNode(_component_el_form_item, {
            prop: "captchaCode"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_input, {
                ref: "captchaCode",
                modelValue: loginForm.captchaCode,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                  return loginForm.captchaCode = $event;
                }),
                placeholder: "验证码",
                "auto-complete": "off",
                name: "captchaCode",
                maxlength: "4",
                tabindex: "3",
                style: {
                  "width": "70%"
                },
                onKeyup: _withKeys(handleLogin, ["enter"])
              }, {
                prefix: _withCtx(function () {
                  return [_createVNode(_component_IEpLock)];
                }),
                _: 1
              }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
                class: "captcha",
                style: {
                  "height": "38px",
                  "cursor": "pointer",
                  "width": "90px"
                },
                src: captchaImage.value,
                alt: "验证码",
                onClick: refreshCaptcha
              }, null, 8, _hoisted_4)])];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            loading: loading.value,
            type: "primary",
            style: {
              "width": "100%",
              "margin-bottom": "30px"
            },
            onClick: _withModifiers(handleLogin, ["prevent"])
          }, {
            default: _withCtx(function () {
              return _cache[4] || (_cache[4] = [_createTextVNode("登录 ")]);
            }),
            _: 1
          }, 8, ["loading"])];
        }),
        _: 1
      }, 8, ["model"])]);
    };
  }
});